@for (navRow of config?.navItems; track navRow; let i = $index) {
  <div
    (click)="handleSubnavItemClicked.emit(navRow)"
    *ngLet="navRow.prop === activeNavItem as isActiveItem"
    class="subnav__row u-flex"
    [ngClass]="{ 'is-active': isActiveItem, 'is-border': config?.border }"
    [attr.data-test-id]="'simpleSubnavRow_' + i"
  >
    @if (navRow.icon) {
      <i
        class="icon icon--medium"
        [attr.data-test-id]="'simpleSubnavIconRow_' + i"
        [innerHTML]="navRow.icon"
      >
      </i>
    }
    <p
      class="t-data"
      [attr.data-test-id]="'simpleSubnavTextRow_' + i"
      [ngClass]="{ 't-bold': isActiveItem }"
      [innerHTML]="navRow.text"
    ></p>
  </div>
}
